const o="gv:onLocalStorageChange";export{o as LOCAL_STORAGE_CHANGE_EVENT};
//# sourceMappingURL=events.js.map
